export default __webpack_public_path__ + "static/media/i-finalizado.c47da65f.svg";